import { render } from "./glAccount.vue?vue&type=template&id=373a780b&scoped=true"
import script from "./glAccount.vue?vue&type=script&lang=js"
export * from "./glAccount.vue?vue&type=script&lang=js"

import "./glAccount.vue?vue&type=style&index=0&id=373a780b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373a780b"]])

export default __exports__